// AdminLayout.tsx
import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import AppToaster from './components/AppToaster';

const AdminLayout: React.FC = () => {
  return (
    <div className="flex min-h-screen w-full flex-col">
      <Header />
      <main className="flex flex-1 flex-col bg-muted/50 gap-4 p-4 md:p-8">
        <Suspense fallback={<div className="flex-1 flex items-center justify-center">Loading...</div>}>
          <Outlet />
        </Suspense>
      </main>
      <AppToaster />
    </div>
  );
};

export default AdminLayout;